import {Box, Typography} from "@mui/material";
import {Typographies} from "../components/utils/typography_consts";
import React from "react";
import AdminFooter from "../components/layout/footer";
import {Link} from "react-router-dom";

const ERROR_404_IMG = "/img/errors/error_404.jpg";

const NotFoundPage = () => {
    return (
        <>
            <Box sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>

                <Typography variant={Typographies.h2} sx={{textAlign: "center"}} color="primary">
                    What are you looking for?
                </Typography>
                <Link to={"/"}>
                    {/* Ancho fluido con tope: con `width={600}` fijo, en un móvil de 390 px la
                        imagen se salía por los dos lados y arrastraba el documento con ella. */}
                    <img style={{marginTop: "2em", width: "100%", maxWidth: 600, height: "auto"}}
                         src={ERROR_404_IMG}
                         alt="Página no encontrada"/>
                </Link>
            </Box>
            <AdminFooter></AdminFooter>
        </>
    );
};

export default NotFoundPage;